// Layout.js
import React from 'react';
import SideBarManager from './manager/SideBarManager';
import InactivityTimer from './InactivityTimer';


const Layout = ({ children }) => {
  return (
    <InactivityTimer>
      <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
        <div style={{ display: 'flex', flex: '1 1 auto', height: '90%' }}>
          <SideBarManager style={{ flex: '0 1 auto', height: '100%' }} />
          <div style={{ flex: '1 1 auto', overflowY: 'auto' }}>
            {children} {/* Renderiza los hijos (las rutas) aquí */}
          </div>
        </div>
      </div>
    </InactivityTimer>
  );
};

export default Layout;